export default [{
	path: '',
	name: 'g_tool',
	meta: {
		authFree: true
	},
	component: () => import('@/pages/tool/index')
}, {
	path: 'batch_image',
	name: 'm_batch_upload',
	meta: {
		title: '批量传图'
	},
	component: () => import('@/pages/tool/batch_image')
}, {
	path: 'scan_view',
	name: 'm_scan_view',
	meta: {
		title: '扫码看图'
	},
	component: () => import('@/pages/tool/scan_view')
}];